import isValid from 'date-fns/is_valid';
import isAfter from 'date-fns/is_after';
import differenceInYears from 'date-fns/difference_in_years';
/**
 * Do not remove this file is being used for coborrower consent identity landing page
 * src/pages/coborrower-consent/pages/identity
 */

const validator = require('ui-validator');

const isValidDOB = validator.createValidator((options, value, key, attributes) => {
  const keyRegex = /^monthBirth(\w*)/;
  const match = key.match(keyRegex);
  const invalidMsg = 'A valid date of birth is required';

  if (match) {
    // empty str or 'Secondary' for joint || Single or SingleSecondary for singleDOB input for personal-loan
    const suffix = match[1];
    const month = attributes[`monthBirth${suffix}`];
    const day = attributes[`dayBirth${suffix}`];
    const year = attributes[`yearBirth${suffix}`];

    if (['', '00'].includes(month) || ['', '00'].includes(day) || ['', '0000'].includes(year) || year.length !== 4) {
      return invalidMsg;
    }

    const dob = new Date(year, parseInt(month, 10) - 1, day); // js Date month is zero-based
    if (dob.getMonth() !== parseInt(month, 10) - 1) return invalidMsg; // fix js Date auto correction
    if (!isValid(dob) || !isAfter(dob, new Date(1900, 0, 1))) {
      return invalidMsg;
    }
    const age = differenceInYears(new Date(), dob);
    if (age < 18) {
      return 'You must be at least 18 years old to apply';
    }

    return undefined;
  }

  return invalidMsg;
});

const validations = {
  monthBirth: {
    validDate: isValidDOB(),
  },
  dayBirth: {},
  yearBirth: {},
};

export default validations;

